"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const businesswoman_webp_1 = __importDefault(require("../../../../assets/images/businesswoman.webp"));
const yellow_check_webp_1 = __importDefault(require("../../../../assets/images/yellow_check.webp"));
require("./AdvantagesStyles.scss");
const Advantages = (0, react_1.forwardRef)((_, ref) => {
    return (react_1.default.createElement("div", { className: "Advantages", ref: ref },
        react_1.default.createElement("div", { className: "left-content" },
            react_1.default.createElement("span", { className: "advantages-sub-title" },
                "Muitas",
                react_1.default.createElement("span", null, ` Vantagens`)),
            react_1.default.createElement("span", { className: "advantages-description" }, "Em apenas dois anos de opera\u00E7\u00E3o, j\u00E1 contamos com mais de 300 im\u00F3veis administrados sob uma estrutura confi\u00E1vel, rent\u00E1vel e inovadora"),
            react_1.default.createElement("div", { className: "advantages-check" },
                react_1.default.createElement("span", null,
                    react_1.default.createElement("img", { src: yellow_check_webp_1.default, alt: "" }),
                    "Rentabilidade at\u00E9 35% maior do que imobili\u00E1rias tradicionais"),
                react_1.default.createElement("span", null,
                    react_1.default.createElement("img", { src: yellow_check_webp_1.default, alt: "" }),
                    "Mais de 100 investidores na plataforma 360 Su\u00EDtes"),
                react_1.default.createElement("span", null,
                    react_1.default.createElement("img", { src: yellow_check_webp_1.default, alt: "" }),
                    "Fundos de investimentos parceiros com recursos internacionais"))),
        react_1.default.createElement("img", { src: businesswoman_webp_1.default, alt: "woman", className: "woman" })));
});
exports.default = Advantages;
